import { FC, PropsWithChildren } from 'react';
import { Typography } from '@mui/material';
import cn from 'classnames';

export interface IFormTitleProps extends PropsWithChildren {
	className?: string;
	testId?: string;
}

export const FormTitle: FC<IFormTitleProps> = ({
	children,
	testId,
	className,
}) => {
	return (
		<Typography
			className={cn('title', className)}
			variant="h2"
			data-testid={testId}
			textAlign="center"
			color="primary.main"
		>
			{children}
		</Typography>
	);
};
